import logger from '../../../utils/logger';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';
import { timerKey } from '../../../utils/timer-manager/timer-manager';

export const stopOriginalBin = (batchStore: any, originalBin: Device, originalMaterial: Material, scale: Device) => {
  if (!originalBin) return;

  if (originalBin.gateOnePNo && batchStore.isOutputOn(originalBin.gateOnePNo)) {
    batchStore.setOutput(originalBin.gateOnePNo, '0');
    logger.log('Closed original bin gate:', originalBin.id, originalBin.description);
  }

  batchStore.stopAttachedDevices(originalBin.id);

  batchStore.timers.clear(timerKey.device(originalBin.id));
  batchStore.timers.clear(timerKey.batchMaterial(originalMaterial.itemId));
  batchStore.timers.clear(timerKey.device(scale.id));
  batchStore.timers.clear(timerKey.checkFinalWeight(originalMaterial.itemId));

  if (batchStore.finishFeedDevices.includes(originalBin.id)) {
    batchStore.finishFeedDevices = batchStore.finishFeedDevices.filter((id: any) => id !== originalBin.id);
  }
};

export const handleDeferredWeight = (batchStore: any, scaleId: string, originalBin: Device, substituteBin: Device): number => {
  let deferredWeight = 0;

  if (originalBin && batchStore.deferredFeedDevices.has(scaleId) && batchStore.deferredFeedDevices.get(scaleId).has(originalBin.id)) {
    deferredWeight = batchStore.deferredFeedDevices.get(scaleId).get(originalBin.id);
    batchStore.deferredFeedDevices.get(scaleId).delete(originalBin.id);

    if (!batchStore.deferredFeedDevices.has(scaleId)) {
      batchStore.deferredFeedDevices.set(scaleId, new Map());
    }
    batchStore.deferredFeedDevices.get(scaleId).set(substituteBin.id, deferredWeight);

    logger.log('Transferred deferred weight from bin', originalBin.id, 'to bin', substituteBin.id, 'weight:', deferredWeight);
  }

  return deferredWeight;
};
